import AnchorLink from 'react-anchor-link-smooth-scroll'
import React from 'react'

class LeadComponent extends React.Component {
  render() {
    const { language, leadText, subText } = this.props
    let designClassName = this.props.designClassName || ''
    const showCta = this.props.showCta!==undefined ? this.props.showCta : true
    let ctaText = 'Kontaktieren Sie uns jetzt unverbindlich'
    if (language==='en') {
      ctaText = 'Get in touch and send us a message'
    }
    return (
      <div id="lead-outer-wrapper" className={designClassName}>
        <div id="lead-wrapper" className="owl-carousel owl-carousel-fullwidth">
          <div className="item">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="fh5co-owl-text-wrap">
                    <div className="fh5co-owl-text">
                      <h1 className="fh5co-lead"><div dangerouslySetInnerHTML={{__html: leadText }}/></h1>
                      <h2 className="fh5co-sub-lead"><div dangerouslySetInnerHTML={{__html: subText }}/></h2>
                      {showCta===true &&
                        <p>
                          <AnchorLink className="btn btn-primary btn-lg" href="#contact"><i className="far fa-comment-alt"></i> {ctaText}</AnchorLink>
                        </p>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="header-separator header-separator-bottom ">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" preserveAspectRatio="none">
              <path className="svg-white-bg" d="M737.9,94.7L0,0v100h1000V0L737.9,94.7z"></path>
            </svg>
          </div>
        </div>
      </div>
    )
  }
}

export default LeadComponent



// WEBPACK FOOTER //
// ./src/components/LeadComponent/index.js